import { createContext, useContext } from "react";

export type ToastKind = "ok" | "error";
export const ToastCtx = createContext<(msg: string, kind?: ToastKind) => void>(() => {});
export const useToast = () => useContext(ToastCtx);
